export const productConnectionFragment = /* GraphQL */ `
	fragment productConnection on ProductConnection {
		pageInfo {
			endCursor
			hasNextPage
		}
		nodes {
			id
			handle
		}
	}
`

const getAllProductPathsQuery = /* GraphQL */ `
	query getAllProducts($first: Int = 250, $after: String = null) {
		products(first: $first, after: $after) {
			...productConnection
		}
	}

	${productConnectionFragment}
`
export default getAllProductPathsQuery
